import React from "react";
import { FaGithub, FaYoutube, FaGlobe } from "react-icons/fa";

function Projects() {
  const projects = [
    {
      title: "TCF AI Tutor",
      description: "Self-hosted LLM tutor stack with a backend-switchable inference gateway, metrics, and eval-gated deployment workflow.",
      tech: ["Python", "FastAPI", "LangGraph", "Kubernetes", "Prometheus", "Argo"],
      github: "https://github.com/YaoyiW27/tcf-ai-tutor"
    },
    {
      title: "Empress of Japan Capstone",
      role: "Team capstone — owned the AWS infrastructure",
      description: "AWS infrastructure for a RAG-based museum exhibit app, built with Terraform, ECS Fargate, RDS, SQS, and CI/CD.",
      tech: ["Terraform", "AWS", "ECS", "RDS", "SQS", "OpenTelemetry"],
      github: "https://github.com/YaoyiW27/empress-of-japan-capstone",
      website: "https://d2kekuy8p1ofvv.cloudfront.net"
    },
    {
      title: "Mastodon Scaling Study",
      role: "Two-person team",
      description: "Scaling experiments on Mastodon's distributed architecture with load testing, bottleneck analysis, and performance notes.",
      tech: ["Python", "Docker", "Load Testing", "Distributed Systems", "Performance"],
      github: "https://github.com/YaoyiW27/mastodon-scaling-study",
      demo: "https://youtu.be/8CD8hdcGNhc"
    },
    {
      title: "Go Resilience Patterns",
      description: "Fail fast, circuit breaker, and bulkhead written from scratch in Go, measured against an injected cascading failure — 45x throughput recovery.",
      tech: ["Go", "Locust", "Docker", "Microservices"],
      github: "https://github.com/YaoyiW27/go-resilience-patterns"
    },
    {
      title: "CUDA Kernel Lab",
      description: "Hand-written CUDA kernels for ML operations, validated against PyTorch and benchmarked with CUDA events.",
      tech: ["CUDA C++", "Python", "PyTorch", "Benchmarking"],
      github: "https://github.com/YaoyiW27/cuda-kernel-lab"
    },
    {
      title: "Bookly",
      description: "Online book community with Google Books search, bookmarks, JWT auth, and discussion features.",
      tech: ["React", "Node.js", "MySQL", "Prisma", "JWT", "Google Books API"],
      github: "https://github.com/YaoyiW27/cs5610-web-app",
      demo: "https://www.youtube.com/watch?v=uZTijQpb6hA"
    },
    {
      title: "Spark",
      description: "Mobile social app with map-based discovery, profiles, matching, and shared moments.",
      tech: ["React Native", "Expo", "Node.js", "Firebase", "Redux", "GeoJS API"],
      github: "https://github.com/YaoyiW27/cs5520-mobile-app",
      demo: "https://youtu.be/dpLnQXJyLyc"
    },
    {
      title: "Personal Portfolio",
      description: "Responsive portfolio site for projects, resume, GitHub activity, and contact.",
      tech: ["React", "CSS", "React Bootstrap", "EmailJS", "Netlify"],
      website: "https://yaoyiw.netlify.app/"
    },
    {
      title: "Cosmic Explorer",
      description: "NASA Open APIs app for browsing astronomy photos and Earth imagery.",
      tech: ["Python", "Streamlit", "NASA API"],
      github: "https://github.com/YaoyiW27/CS5001",
      website: "https://cs5001-cosmos.streamlit.app/",
      demo: "https://youtu.be/FZcuDyRFKnQ"
    }
  ];

  return (
    <div className="projects-container">
      <div className="projects-grid">
        {projects.map((project, index) => (
          <div key={index} className="project-card">
            <h3>{project.title}</h3>
            {project.role && <p className="project-role">{project.role}</p>}
            <p className="project-description">{project.description}</p>
            <div className="tech-stack">
              {project.tech.map((tech, idx) => (
                <span key={idx} className="tech-tag">{tech}</span>
              ))}
            </div>
            <div className="project-links">
              {project.github && (
                <a href={project.github} target="_blank" rel="noopener noreferrer" className="project-link">
                  <FaGithub /> Code
                </a>
              )}
              {project.demo && (
                <a href={project.demo} target="_blank" rel="noopener noreferrer" className="project-link">
                  <FaYoutube /> Demo
                </a>
              )}
              {project.website && (
                <a href={project.website} target="_blank" rel="noopener noreferrer" className="project-link">
                  <FaGlobe /> Live
                </a>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Projects;
